import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { useCanvasStore } from '@/modules/canvas/store';
import { useReferenceImageUIStore } from '../store';

import { IReferenceImageService } from './IReferenceImageService';
import { ReferenceImageServiceImpl } from './ReferenceImageServiceImpl';

export class ReferenceImageServiceFactory {
  private static instance: ReferenceImageServiceFactory | null = null;
  private floorplanDesignStore: typeof useFloorplanDesignStore;
  private referenceImageUIStore: typeof useReferenceImageUIStore;
  private canvasStore: typeof useCanvasStore;

  public static initialize(
    floorplanDesignStore: typeof useFloorplanDesignStore,
    canvasStore: typeof useCanvasStore,
    referenceImageUIStore: typeof useReferenceImageUIStore,
  ) {
    ReferenceImageServiceFactory.instance = new ReferenceImageServiceFactory(
      floorplanDesignStore,
      canvasStore,
      referenceImageUIStore,
    ); 
  }

  public static getInstance() {
    if (ReferenceImageServiceFactory.instance === null) {
      throw new Error(
        'ReferenceImageServiceFactory not yet initialized. Call ReferenceImageServiceFactory.initialize() first.',
      );
    }
    return ReferenceImageServiceFactory.instance;
  }

  private constructor(
    floorplanDesignStore: typeof useFloorplanDesignStore,
    canvasStore: typeof useCanvasStore,
    referenceImageUIStore: typeof useReferenceImageUIStore,
  ) {
    this.floorplanDesignStore = floorplanDesignStore;
    this.canvasStore = canvasStore;
    this.referenceImageUIStore = referenceImageUIStore;
  }

  public createService(): IReferenceImageService {
    const result: IReferenceImageService = this.makeService();

    return result;
  }

  private makeService(): IReferenceImageService {
    return new ReferenceImageServiceImpl(
      this.floorplanDesignStore,
      this.canvasStore,
      this.referenceImageUIStore,
    );
  }
}
